import { KpiMeta } from '../config/kpi-config';
import { tailwindClasses } from '../styles/tokens';

export function formatValue(v: number, meta: KpiMeta): string {
  if (isNaN(v) || !isFinite(v)) return 'N/A';
  
  switch (meta.type) {
    case 'andel':
      return `${v.toFixed(1)} %`;
    case 'poäng':
      return `${v.toFixed(1)} p`;
    case 'kvot':
      return v.toFixed(1);
    case 'antal':
      return new Intl.NumberFormat('sv-SE').format(Math.round(v));
    case 'procent':
      return `${v.toFixed(1)} %`;
    case 'kr':
      return `${Math.round(v).toLocaleString('sv-SE')} kr`;
    default:
      return v.toFixed(1);
  }
}

export function formatDelta(d: number, meta: KpiMeta): string {
  if (isNaN(d) || !isFinite(d)) return 'N/A';
  
  const sign = d >= 0 ? '+' : '';
  
  switch (meta.deltaUnit) {
    case 'p.p.':
      return `${sign}${d.toFixed(1)} p.p.`;
    case 'p':
      return `${sign}${d.toFixed(1)} p`;
    case 'st/HT':
      return `${sign}${d.toFixed(1)} st/HT`;
    case 'kr':
      return `${sign}${Math.round(d).toLocaleString('sv-SE')} kr`;
    default:
      return `${sign}${d.toFixed(1)} ${meta.deltaUnit}`;
  }
}

export function getDeltaColor(delta: number, higherIsBetter: boolean | null): string {
  if (higherIsBetter === null) return `${tailwindClasses.neutral.bg} ${tailwindClasses.neutral.text}`;
  
  const isPositive = delta > 0;
  const isGood = isPositive === higherIsBetter;
  
  if (isGood) {
    return `${tailwindClasses.positive.bg} ${tailwindClasses.positive.text}`;
  } else {
    return `${tailwindClasses.negative.bg} ${tailwindClasses.negative.text}`;
  }
}

export function getDeltaArrow(delta: number, higherIsBetter: boolean | null): string {
  if (higherIsBetter === null) return '→'; // Neutral
  
  const isPositive = delta > 0;
  const isGood = isPositive === higherIsBetter;
  
  if (isGood) {
    return isPositive ? '↗' : '↘';
  } else {
    return isPositive ? '↗' : '↘';
  }
}
